import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import Modal from '../../components/Modal';
import CashbackPresenter from '../../presenters/CashbackPresenter';
import {
  validationSchema,
  initialValues,
} from '../../forms/cashback/editStateForm';
import { ErrorFlash } from '../../components';

import StateChangeForm from './components/StateChangeForm';

const StateChangeModal = (props) => {
  const {
    cashbackParams,
    onEditCashbackStateDialogClose,
    isEditDialogOpen,
    onSubmit,
    errors,
  } = props;

  return (
    <Modal
      title="Change Cashback State"
      isModalOpen={isEditDialogOpen}
      onClose={onEditCashbackStateDialogClose}
    >
      <ErrorFlash errors={errors} message={errors} />
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => onSubmit(values, actions)}
        initialValues={initialValues(cashbackParams)}
        validationSchema={validationSchema}
        render={(formikProps) => (
          <StateChangeForm
            {...formikProps}
            onModalClose={onEditCashbackStateDialogClose}
            availableStates={CashbackPresenter.availableStates(cashbackParams)}
          />
        )}
      />
    </Modal>
  );
};

export default StateChangeModal;

StateChangeModal.propTypes = {
  cashbackParams: CashbackPresenter.shape().isRequired,
  onEditCashbackStateDialogClose: PropTypes.func.isRequired,
  isEditDialogOpen: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.shape()),
};

StateChangeModal.defaultProps = {
  errors: null,
};
